/*
 * @Author: ningbo.kang
 * @Date: 2019-09-29 14:50:16
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-07-21 16:32:44
 * @FilePath: /fed-authority/src/api/system/menu.js
 * @Description: 描述
 */

import db from '../db';
import dbAuthority from '../dbAuthority';

/**
 * [model 系统管理模块]
 * @type {Object}
 */
const model = {
  /**
   *
   * 系统管理-菜单管理
   */
  // 获取菜单管理-api 菜单列表分页数据
  getMenuList(param) {
    return db.post('/sys/menu/list', param);
    // return db.post('/sys/menu/page', param);
  },

  // 添加一个菜单
  addMenuItem(param) {
    return db.post('/sys/menu/create', param);
  },

  // 编辑单个菜单
  editMenuItem(param) {
    return db.post('/sys/menu/modify', param);
  },

  // 删除单个菜单项目
  deleteMenuItem(menuId) {
    // return db.delete(`/system/menu/delete/${menuId}`);
    return db.post(`/sys/menu/delete/${menuId}`);
  },
  // 批量删除菜单
  deleteMenuItems(menuIds) {
    return db.post('/system/menu/batchdelete', menuIds);
  },
  // 左侧memu菜单数据
  getSideBarMenu(param) {
    // 菜单数据服务器端不是树状，客户端做了处理
    // if (process.env.VUE_APP_PREVIEW === 'true') {
    //   const { hostname, port, pathname } = window.location;
    //   return db.get(`//${hostname}:${port}${pathname}mock/system/menu/menuExt.json`, param);
    // }
    return dbAuthority.get('/menu/app/user', param);
    // return dbAuthority.post('/sys/menu/userMenus', param);
  },
};

export default model;
